import { CSSObject } from '@mantine/core';
import { MantineThemeComponent } from '../../types';
import { headings } from '../../tokens/typography/typography';

const ModalDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		size: 'md',
		centered: true,
		closeButtonProps: { 'size': 24, 'aria-label': 'Close modal' },
		closeOnEscape: false,
		overlayProps: { sx: { backgroundColor: 'var(--color-modal-backdrop)' } }
	},
	styles: theme => ( {
		inner: {
			padding: 0
		},
		close: {
			color: theme.fn.themeColor( 'dark', 3 )
		},
		title: {
			...( headings.h4 as CSSObject )
		},
		body: {
			padding: '0 24px 8px'
		}
	} )
};

export default ModalDefaultConfig;
